import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
    selector   : 'eguard-nav-vertical-item',
    templateUrl: './nav-vertical-item.component.html',
    styleUrls  : ['./nav-vertical-item.component.scss']
})
export class EguardNavVerticalItemComponent implements OnInit
{
    @HostBinding('class') classes = 'nav-item';
    @Input() item: any;

    constructor()
    {
    }

    ngOnInit()
    {
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/navigation/vertical/nav-item/nav-vertical-item.component.ts